import "./polyfills/Node.js";
import "./polyfills/NodeList.js";
import "./polyfills/Object.js";
import Glide from '@glidejs/glide/dist/glide.esm';
//import Glide, { Breakpoints } from '@glidejs/glide/dist/glide.modular.esm'


//navbar toggle button on mobile
window.addEventListener("load", () => {
  var toggleBtn = document.querySelector(".nav-toggle");

  toggleBtn.addEventListener("click", showNav);

  function showNav() {
    var navBar = document.querySelector(".nav-menu");
    navBar.classList.toggle("active");
  }
});

//service block "learn more" button functionality
let service_blocks = document.querySelectorAll('[data-service-name]');
service_blocks.forEach((block) => {
  block.addEventListener('mouseenter', () => {
    document.querySelectorAll('[data-image-service].hover').forEach((image) => {
      image.classList.remove('hover');
    })
    let service_name = block.dataset.serviceName;
    let hover_image = document.querySelector(`[data-image-service="${service_name}"]`);
    if(hover_image) {
      hover_image.classList.add('hover');
    }
  });

  block.addEventListener('mouseleave', () => {
    document.querySelectorAll('[data-image-service].hover').forEach((image) => {
      image.classList.remove('hover');
    })
  });
});


//CASE STUDY PAGE CAROUSEL
// console.log(window.location.pathname);
// if(window.location.pathname != '/'){
  
// window.plusSlides = function(n) {
//   showSlides(slideIndex += n)
// }

// var slideIndex = 1;
// showSlides(slideIndex);

// // Thumbnail image controls
// function currentSlide(n) {
//   showSlides(slideIndex = n);
// }

// function showSlides(n) {
//   var i;
//   var slides = document.getElementsByClassName("mySlides");
//   console.log(slides);
//   if (n > slides.length) {slideIndex = 1}
//   if (n < 1) {slideIndex = slides.length}
//   for (i = 0; i < slides.length; i++) {
//       slides[i].style.display = "none";
//   }
//   slides[slideIndex-1].style.display = "block";
// }
// }


//CASE STUDY BLOCK CAROUSEL
// var slideIndex = [1,1];
// /* Class the members of each slideshow group with different CSS classes */
// var slideId = ["Slides", "TestimonialSlides"]
// showSlides(1, 0);
// showSlides(1, 1);

// window.plusSlides = function(n, no) {
//   showSlides(slideIndex[no] += n, no);
// }

// function showSlides(n, no) {
//   var i;
//   var x = document.getElementsByClassName(slideId[no]);
//   if (n > x.length) {slideIndex[no] = 1}
//   if (n < 1) {slideIndex[no] = x.length}
//   for (i = 0; i < x.length; i++) {
//     x[i].style.display = "none";
//   }
//   x[slideIndex[no]-1].style.display = "block";
// }



//TESTIMONIAL BLOCK CAROUSEL
// document.addEventListener("DOMContentLoaded", function(){
//   var slideIndex = 1;
// showSlides(slideIndex);

// window.plusSlides = function(n) {
//   showSlides(slideIndex += n)
// }



// // Thumbnail image controls
// function currentSlideTestimonial(n) {
//   showSlides(slideIndex = n);
// }

// function showSlidesTestimonial(n) {
//   var i;
//   var slides = document.getElementsByClassName("TestimonialSlides");
  
//   if (n > slides.length) {slideIndex = 1}
//   if (n < 1) {slideIndex = slides.length}
//   for (i = 0; i < slides.length; i++) {
//       slides[i].style.display = "none";
//   }
//   slides[slideIndex-1].style.display = "block";
// }
// });


//logo slider 
// if(document.querySelectorAll('.glide').length){
//   new Glide('.glide' , {
//     type: 'carousel',
//     startAt: 0,
//     perView: 3,
//     breakpoints: {
//       600: {
//           perView: 1
//       }
//     }
//   }).mount()
// }

var sliders = document.querySelectorAll('.glide');

for (var i = 0; i < sliders.length; i++) {
  var glide = new Glide(sliders[i], {
    type: 'carousel',
    startAt: 0,
    perView: 3,
    breakpoints: {
      900: {
          perView: 1
      }
    }
  });
  
  glide.mount();
}

var sliders = document.querySelectorAll('.glideTestimonial');

for (var i = 0; i < sliders.length; i++) {
  var glide = new Glide(sliders[i], {
    type: 'carousel',
    startAt: 0,
    perView: 1,
  });
  
  glide.mount();
}





//sticky nav
if (window.innerWidth > 760) {
window.onscroll = function() {scrollFunction()};
}

function scrollFunction() {
  
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      document.getElementById("resize-logo").style.width = "40%";
      document.getElementById("resize-logo").style.margin = "auto auto 0 0";
      document.getElementById("navigation").style.height = "80px";
      document.querySelector(".nav-logo").style.height = "80px";
      document.querySelector(".header-right").style.height = "80px";
      document.querySelector(".header-phone").style.width = "120px";
      document.querySelector(".header-phone").style.fontSize = "16px";
  
    } else {
      document.getElementById("navigation").style.height = "150px";
      document.getElementById("resize-logo").style.width = "90%";
      document.getElementById("resize-logo").style.margin = "auto auto 0 0";
      document.querySelector(".nav-logo").style.height = "150px";
      document.querySelector(".header-right").style.height = "150px";
      document.querySelector(".header-phone").style.width = "120px";
    }
  }
  

// function setActive() {
//   linkObj = document.querySelectorAll('nav-menu');
//   console.log(linkObj);
//   for(i=0;i<linkObj.length;i++) { 
//     if(document.location.href.indexOf(linkObj[i].href)>=0) {
//       linkObj[i].classList.add("active");
//     }
//   }
// }
  
(function() {
  var nav = document.getElementById('nav');
      
     var anchor = nav.getElementsByTagName('a');
     
      var current = window.location.pathname.split('/')[1];
      //console.log(window.location.pathname);
      //console.log(current);
      for (var i = 0; i < anchor.length; i++) {
        //console.log(anchor[i].href.split('/')[3]);
        //console.log(anchor[i].href.split('/')[1]);
        //console.log(anchor[i].classList.contains('dropdown-link'));
      if(anchor[i].href.split('/')[3] == current && anchor[i].classList.contains('dropdown-link') == false) {
        anchor[i].className = "navbar-active";
      }
    }
    if(document.URL.indexOf("case-study") >= 0) {
      var caseStudy = document.getElementById('case-study-link');
      caseStudy.className = "navbar-active";
    }
    if(document.URL.indexOf("service") >= 0) {
      var serviceLink = document.getElementById('services-link');
      serviceLink.className = "navbar-active";
    }
})();